import { render, staticRenderFns } from "./CoopcheckerDash.vue?vue&type=template&id=67dbb1c0"
import script from "./CoopcheckerDash.vue?vue&type=script&lang=js"
export * from "./CoopcheckerDash.vue?vue&type=script&lang=js"
import style0 from "./CoopcheckerDash.vue?vue&type=style&index=0&id=67dbb1c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports